import { PostTextCompany } from "./ApiCalls/textCompany/postTextCompany";
import { PatchTextCompany } from "./ApiCalls/textCompany/patchTextCompany";
import { DisabletextCompany } from "./ApiCalls/textCompany/disableTextCompany";

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const modifiedBy = authInfo.idUser;

export async function PostTextCompanyService(textCompany) {
  const responseTextCompany = PostTextCompany(textCompany, modifiedBy);

  return responseTextCompany;
}

export async function PatchTextCompanyService(textCompany, idtextCompany) {
  const responseTextCompany = PatchTextCompany(textCompany, modifiedBy, idtextCompany);

  return responseTextCompany;
}

export async function DisabledTextCompanyService(idtextCompany) {
  try {
    const textCompanyData = await DisabletextCompany(modifiedBy, idtextCompany);
    return textCompanyData;
  } catch (error) {
    console.error("Error during disable textCompany:", error);
    // Manejar el error
    throw error;
  }
}